export const environment = {
    production: false,
    apiUrl: 'https://crm.staging.div25.com',
    reportingApiUrl: 'https://reporting.staging.div25.com',
    SalesAppClientBaseUrl: 'https://sales.staging.div25.com',
    SalesAppClientProjectOverviewUrl: 'project'
};
